import styled from '@emotion/styled';
import { Breadcrumb, Button, Drawer, Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { FaArrowLeft, FaHome, FaPlus } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { AgenceEntity } from '../../../../entities/agence.entity';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import { ROUTES } from '../../../../routes';
import { PRIMARY } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { AgenceForm } from '../components/AgenceForm';
import { SideBar } from '../components/SidebarItems';
import { getCustomUtilisateurs } from '../network';

const Container = styled.div`
  height: calc(100vh - 30px);
  background-color: white;
  display: flex;

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .style-row {
    &:hover > td {
      background-color: #eee !important;
      cursor: pointer;
    }
  }

  .link {
    text-decoration: underline;
    cursor: pointer;
  }

  > .content {
    padding: 50px;
    width: 85%;
    background-color: #e8edea;
  }
`;

export const AgencePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const partner = (useLocation().state as any)?.partner;
  const [agences, setAgences] = useState<AgenceEntity[]>();
  const [filterAgences, setFilterAgences] = useState<AgenceEntity[]>();
  const [users, setUsers] = useState<UserEntity[]>([]);
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const history = useHistory();

  useEffect(() => {
    if (partner) {
      setAgences(partner.agences);
      setFilterAgences(partner.agences);
    } else {
      history.push(ROUTES.PANEL.ADMIN.PARTENAIRE);
    }

    getCustomUtilisateurs(connectedUser.id).then(({ data }) => {
      setUsers(data);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const COLUMNS = [
    {
      title: 'Code Agence',
      dataIndex: 'code',
    },
    {
      title: 'Agence',
      dataIndex: 'nom',
    },
    {
      title: 'Localisation',
      dataIndex: 'localisation',
    },
    {
      title: "Nombre d'utilisateur",
      render: (cell: any, row: AgenceEntity) => {
        return `${users.filter((u) => u.agence === row.url).length || 0}`;
      },
    },
  ];

  return (
    <Layout hideYellowScrollInfo>
      <Container>
        <SideBar defaultOpenKeys={['m1']} current='1.1' />{' '}
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <FaHome style={{ marginRight: 5 }} />
              <span>Administration</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item
              onClick={() => history.push(ROUTES.PANEL.ADMIN.PARTENAIRE)}
            >
              <span className='link'>Partenaires</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Agences</span>
            </Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: 20 }}>
            <div
              style={{
                borderRadius: '50%',
                padding: 5,
                backgroundColor: PRIMARY,
                width: 40,
                height: 40,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: 5,
              }}
              onClick={() => history.goBack()}
            >
              <FaArrowLeft size={20} />
            </div>

            <h2>Liste des Agences - {partner?.nom}</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Input
                placeholder='Search...'
                style={{ width: 250 }}
                onChange={(e) => {
                  setFilterAgences(
                    agences?.filter(
                      (age) =>
                        age.nom
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()) ||
                        age.localisation
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()),
                    ),
                  );
                }}
              />

              <Button
                icon={<FaPlus style={{ marginBottom: -2, marginRight: 5 }} />}
                className='butt'
                style={{ borderRadius: 5 }}
                onClick={() => setShowDrawer(true)}
              >
                Nouvel Agence
              </Button>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={filterAgences}
              rowKey='id'
              rowClassName='style-row'
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={false}
              onRow={(row, rowIndex) => {
                return {
                  onClick: (event) => {
                    history.push(ROUTES.PANEL.ADMIN.AGENCE_USERS, {
                      agence: row,
                      users: users.filter((u) => u.agence === row.url),
                    });
                  }, // click row
                  onDoubleClick: (event) => {}, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </div>
        <Drawer
          title='Ajouter une agence'
          placement='right'
          width={400}
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <AgenceForm
            partenaire={partner}
            setShowDrawer={setShowDrawer}
            getNewAgence={(age) => {
              setAgences([...(agences as AgenceEntity[]), age]);
              setFilterAgences([...(filterAgences as AgenceEntity[]), age]);
            }}
          />
        </Drawer>
      </Container>
    </Layout>
  );
};
